<template>
<div>
  <v-treeview
    :items="items"
    checkbox
    root
    expand-all
    v-model="selectedItems"
    icon-field="icon"
    ></v-treeview>
</div>
</template>

<script>

export default {
  name: 'Gallery',
  data: () => ({
    items: {
      id: 0,
      name: 'Root',
      children: [
        {
          id: 1,
          name: 'First Children',
          children: null
        },
        {
          id: 2,
          name: 'Second Children',
          children: [
            {
              id: 3,
              name: 'GrandChildren1',
              icon: 'account_circle'
            },
            {
              name: 'GrandChildren2'
            },
            {
              name: 'GrandChildren3'
            }
          ]
        }
      ]
    },
    selectedItems: []
  })
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/Gallery.vue